<template>
    <a-modal :visible="visible" title="Sửa đơn chỉnh sửa công" :footer="null" @ok="handleOk" @cancel="handleCancel" :destroyOnClose="true" centered>
        <UpdateAdditionalTimesheet :id="id" @cancel="handleFormCancel" @ok="handleFormOk"/>
    </a-modal>
</template>
<script>
import UpdateAdditionalTimesheet from '../UpdateAdditionalTimesheet.vue';
export default {
    name: "EditAdditionalTimesheetModal",
    components: { UpdateAdditionalTimesheet },
    props: {
        visible: {
            type: Boolean, 
            default: false
        },
        id: {
            type: Number,
            default: null
        }
    },
    methods: {
        handleOk() {
            this.$emit('ok');
        },
        handleCancel(e) {
            this.$emit('cancel', e);
        },
        handleFormCancel(e) {
            this.handleCancel(e);
        },
        handleFormOk(e) {
            this.handleOk(e);
        }
    }
}
</script>
<style lang="scss" scoped>
    /deep/ .ant-modal-mask {
        z-index:1030;
    }
    /deep/ .ant-modal-wrap {
        z-index: 1030;
        &::-webkit-scrollbar {
            display: none;
        }
    }
    /deep/ .ant-modal {
    width: 100% !important;
    max-width: 684px;
    }
    /deep/ .ant-modal-header{
    padding: 16px 24px;
    color: rgba(0, 0, 0, 0.65);
    background: #fff;
    border-bottom: 1px solid #e8e8e8;
    border-radius: 10px 10px 0 0;
    background-color: #d2d6ff;
    border-bottom-color: #3d4cdc;
    .ant-modal-title{
        color: #3d4cdc;
    }
    }
    /deep/ .ant-modal-body {
    padding: 24px;
    font-size: 14px;
    line-height: 1.5;
    word-wrap: break-word;
    }
    /deep/ .ant-modal-content {
    position: relative;
    background-color: #fff;
    background-clip: padding-box;
    border: 0;
    border-radius: 10px;
    // box-shadow: 0 4px 12px rgb(0 0 0 / 15%);
    pointer-events: auto;
   }
    /deep/ .form-data{
        .save-info{
            border-radius: 10px;
            width: 235px;
            height: 40px;
            margin-right: 10px;
            background-color: #3d4cdc;
            border: 2px solid #3d4cdc;
            color: #fff;
            font-size: 14px;
        }
        .cancel-btn{
            // padding: 7px 45px;
            border-radius: 10px;
            width: 235px;
            height: 40px;
            font-weight: 600;
            background: #ECECEC;
            border: 2px solid #ECECEC;
            color: #6F6F6F;
            font-size: 14px;
        }
    }
</style>